<template>
  <transition name="modal">
      <div class="modal-mask">
          <div class="modal-wrapper" @click="$emit('closeModal')">
              <div class="row">
                  <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                  <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                      <div class="modal-container" @click.stop>

                        <div class="modal-header row" style="justify-content: flex-end;border-bottom:none">
                          <button type="button" class="close" @click="$emit('closeModal')">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                          
                          <div class="modal-body text-center">
                                <h2>{{data ? 'Edit' : 'Add New'}} Target</h2>
                                <h5>Fill the form to add new target manually</h5>

								<div class="row mt-3 text-left">
									<div class="col-md-6 p-10">
										<label>Kode Dealer</label>
										<!-- <input type="text" class="form-control" v-model="dataSubmit.kd_dealer" :disabled="disableInput"/> -->
										<MultiSelect 
											:options="dealer.map(x => x.code)"
											:custom-label="opt => dealer.find(x => x.code == opt).name"
											placeholder="Select Dealer"
											:allow-empty="true"
											v-model="dataSubmit.kd_dealer"
										/>
									</div>
									<div class="col-md-6 p-10">
										<label>Kode Kecamatan</label>
										<MultiSelect 
											:options="kecamatan.map(x => x.kodekecamatan)"
											:custom-label="opt => kecamatan.find(x => x.kodekecamatan == opt).name"
											placeholder="Select Kecamatan"
											:allow-empty="true"
											v-model="dataSubmit.kd_kecamatan"
										/>
									</div>
								</div>

								<div class="row mt-2 text-left">
									<div class="col-md-6 p-10">
										<label>Month & Year</label>
										<flat-pickr
											v-model="date"
											class="border border-secondary rounded p-10 w-100"
											:config="rangeConfig"
											placeholder="Select To Date"
											:disabled="disableInput"
											style="height:35px"
										/>
									</div>
									<div class="col-md-6 p-10">
										<label>Target Unit</label>
										<input type="text" class="form-control" v-model="dataSubmit.target_unit" />
									</div>
								</div>

								

								<div class="row mt-3">
									<div class="offset-md-3 col-md-3">
										<button class="btn btn-outline-danger w-100" @click="$emit('closeModal')">Cancel</button>
									</div>
									<div class="col-md-3">
										
										<button class="btn btn-outline-success w-100" @click="submitApi">Submit</button>
									</div>
								</div>

								
                                
                                
                          </div>
                      </div>
                  </div>
                  <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
              </div>
          </div>
      </div>
  </transition>
</template>

<script>
  	import MultiSelect from 'vue-multiselect';

  	import flatPickr from 'vue-flatpickr-component'
	import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
	import 'flatpickr/dist/plugins/monthSelect/style.css'
	import moment from 'moment'

  
  
	export default{
		data(){
			return{
				dataSubmit : null,
				disableInput : null,
				rangeConfig: {
					mode : 'multiple',
					altInputClass: 'form-control w-100',
					animate: !this.isRTL(),
					plugins: [
						new monthSelectPlugin({
							shorthand: true, //defaults to false
							dateFormat: "M Y", //defaults to "F Y"
							altFormat: "F Y", //defaults to "F Y"
							theme: "dark" // defaults to "light"
						})
					]
				},
				date : null
			}
		},
		watch : {
			date : function () {
				let now = new moment(this.date)

				this.dataSubmit.month = now.format('M')
				this.dataSubmit.year = now.format('Y')
			}
		},
		props : ['data' , 'dealer' , 'kecamatan'],
		components : {
			MultiSelect,
			flatPickr
		},
		mounted(){
			this.disableInput = this.data ? true : false
			this.data ? this.dataSubmit = this.data : this.dataSubmit = {
				kd_dealer : null,
				kd_kecamatan : null,
				year : null,
				month : null,
				target_unit : null
			}

			this.date = this.data ? new moment().month(parseInt(this.data.month) - 1).year(this.data.year).format('MMM YY') : null
		},
		methods: {
			
			submitApi : function(){
				let vm = this;
				let url = this.data ?  "/api/target/mcd/" + this.data.uniqueid : '/api/target/mcd'
				let method = this.data ? 'put' : 'post' 

				let data = this.data ? {
					target_unit : this.dataSubmit.target_unit
				} : this.dataSubmit


				this.$http[method](url , data)
				.then((resp)=>{
					vm.$emit('onFinish')
					vm.$emit('closeModal')
				})
				.catch((err)=>{
					this.fileError = "Bulk Input Failed with Given Response From Server " + err;
				})
				
			}
		}
	}
</script>

<style>

</style>

<style scoped>
	.btn-primary {
		background-color : #ff9700;
		border-color: #ff9700;
	}
	.modal-mask {
		position: fixed;
		z-index: 1020;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		display: table;
		transition: opacity .3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 100%;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
	}

	.modal-body {
		margin: 20px 0;
	}

	.modal-default-button {
		float: right;
	}

	/*
	* The following styles are auto-applied to elements with
	* transition="modal" when their visibility is toggled
	* by Vue.js.
	*
	* You can easily play with the modal transition by editing
	* these styles.
	*/

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	/* MODAL STARTS */
	.modal-body{
		margin:0
	}

	.modal-body .moduleLine{
		margin-bottom: 0vh;
	}

	.modal-body .moduleLine a{
		text-decoration: none;
	}

	.modal-body .moduleLine .moduleBox:hover{
		background-color: #E0E0E0;
		transition: background-color 0.7s ease;
		color: #212121;
		transition: color 0.7s ease;
	}

	.modal-body .moduleLine .moduleBox{
		border:1px solid #BDBDBD;
		border-radius: 20px;
		padding: 20px 0;
		color:black;
		margin-bottom: 3vh;
	}

	.modal-body .moduleLine .moduleBox i{
		font-size:5vh;
	}

	h3.modalHeadline{
		margin:0 0 20px 0;
		font-weight: bold;
		text-align : center;
	}

	h2 {
		color : #707070;
	}

	h5 {
		color : #707070;
	}
  /* MODAL ENDS */
</style>